
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.982 5.513c-.228-.274-.493-.47-.835-.665 0 .117-.038.235-.076.352-.038.117-.038.235-.075.313-.721 3.323-2.769 4.73-5.424 5.043-.19.04-.341.04-.53.04H6.727a.794.794 0 00-.796.703l-.759 5.005-.114.664-.265 1.603c-.038.274.152.509.417.509h2.996c.341 0 .645-.274.72-.626l.039-.156.568-3.675.038-.196a.712.712 0 01.72-.625h.456c2.92 0 5.158-1.213 5.84-4.731.266-1.486.114-2.698-.607-3.558z","fill":"#E6E6E6"}}),_c('path',{attrs:{"d":"M5.93 11.338l.038-.195.948-6.256c.038-.234.19-.469.418-.547.113-.04.19-.078.303-.078h4.513c.53 0 1.024.039 1.479.117.114.039.265.039.38.078.113.04.227.078.34.078.038 0 .076.04.114.04h.076c.228.078.417.156.607.273.227-1.486 0-2.502-.796-3.401C13.515.43 11.96 0 9.988 0H4.224a.794.794 0 00-.797.704L1 16.382c-.038.313.19.586.493.586h3.565l.114-.664.758-4.966z","fill":"#fff"}}),_c('path',{attrs:{"d":"M15.145 4.848a2.895 2.895 0 00-.606-.274h-.076c-.038 0-.076-.039-.114-.039-.114-.039-.228-.078-.341-.078-.114-.039-.266-.039-.38-.078a8.747 8.747 0 00-1.479-.117H7.6a.698.698 0 00-.304.078c-.19.117-.38.313-.417.547l-.948 6.256v.195c.076-.43.417-.703.796-.703H9.04c.19 0 .38-.04.531-.04 2.655-.312 4.703-1.72 5.461-5.004.038-.117.038-.195.076-.313 0-.195.038-.313.038-.43z","fill":"#F7F7F7"}})])
          )
        }
      }
    